import { APP_ROUTES } from '@/navigation';

/**
 * The permanent reference to a tune. The workbench resolves `?tune=` against
 * saved tunes, Score Studio scores, the melody lead sheets and then the chord
 * charts (useTuneUrl in SequenceBuilderPage); `source=realbook` reaches the
 * one collection a plain link never does.
 */
export function tuneHref(title: string, composer?: string, source?: 'realbook'): string {
  return `${APP_ROUTES.workbench}?tune=${encodeURIComponent(title)}${
    composer ? `&by=${encodeURIComponent(composer)}` : ''
  }${source ? `&source=${source}` : ''}`;
}
